<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="2"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner">
        <!-- p-0 h-100 overflow-y-hidden -->
        <!-- <img src="~/../assets/images/left-banner.jpg" style="height: 100%;" alt=""> -->
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15">
        <grid-row class="justify-content-center h-100">
            <grid-col col="6" mobile="12">
                <grid-row class="mt-mobile-15 justify-content-center h-100 pb-30">
                    <grid-col col="12">
                        <ng-icon iconClass="icon-verify-yourself mt-mobile-20" width="75" height="62"></ng-icon>
                        <div class="font-400 font-size-20px line-h-25 color-base-700 mt-15">
                            {{ "VerifyYourselfID" | translate }}
                        </div>
                    </grid-col>
                    <grid-col col="12">
                        <grid-row class="align-item-center col-space-min mt-ipad-30">
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-brightness-verify bg-nuetral-primary br-8 p-14" width="56"
                                    height="56"></ng-icon>
                            </grid-col>
                            <grid-col col="9">
                                <div class="font-400 font-size-14px color-base-700 line-h-25">
                                    {{ "MakeSureBrightness" | translate }}
                                </div>
                            </grid-col>
                        </grid-row>
                        <grid-row class="align-item-center col-space-min mt-50">
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-display-verify bg-nuetral-primary br-8 p-14" width="56" height="56"></ng-icon>
                            </grid-col>
                            <grid-col col="9">
                                <div class="font-400 color-base-700 font-size-14px line-h-25">
                                    {{ "DocumentMustDisplay" | translate }}
                                </div>
                            </grid-col>
                        </grid-row>
                        <grid-row class="align-item-center col-space-min mt-50">
                            <grid-col col="auto">
                                <ng-icon iconClass="icon-format-verify bg-nuetral-primary br-8 p-14" width="56" height="56"></ng-icon>
                            </grid-col>
                            <grid-col col="9">
                                <div class="font-400 font-size-14px line-h-25 color-base-700">
                                    {{ "DocumentInformat" | translate }}
                                </div>
                            </grid-col>
                        </grid-row>
                    </grid-col>
                    <grid-col col="12">
                        <grid-row class="justify-content-between align-item-center mt-50">
                            <grid-col col="auto">
                                <div class="mt-15">
                                    <button class="btn-back" (click)="back()">
                                        <i class="icon-back"></i>
                                    </button>
                                </div>
                            </grid-col>
                            <grid-col col="9">
                                <button class="btn-dft" [routerLink]="['/CardRequestUploadId']">
                                    {{ "Next" | translate }}
                                </button>
                            </grid-col>
                        </grid-row>
                        <!-- <button class="btn-dft" [routerLink]="['/CardRequestUploadId']">
                                        {{ "Next" | translate }}
                                    </button> -->
                    </grid-col>
                </grid-row>
            </grid-col>
        </grid-row>
    </div>
</div>